import { type InputHTMLAttributes, type ReactNode, forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

interface Props extends Omit<InputHTMLAttributes<HTMLInputElement>, 'label'> {
  label?: ReactNode;
  error?: string;
}

export const TextField = forwardRef<HTMLInputElement, Props>(function TextField(
  { label, error, className, ...rest },
  ref
) {
  return (
    <label className="block">
      {label && <span className="mb-1 block text-sm font-medium text-text-secondary">{label}</span>}
      <input
        ref={ref}
        className={twMerge(
          'w-full rounded-xl border border-border bg-surface px-4 py-3 text-text-primary outline-none transition focus:border-primary',
          error && 'border-error',
          className
        )}
        {...rest}
      />
      {error && <span className="mt-1 block text-sm text-error">{error}</span>}
    </label>
  );
});
